export function calculateLocation(sweep: any) {
  if (this.state.panoramaOn) return false;
  let px = this.state.mapWalkerX;
  let py = this.state.mapWalkerY;
  const { minimaps } = this.state;
  const { selectedMinimap } = this.state;
  const { tour } = this.state;
  const minimap = minimaps[selectedMinimap];
  if (
    tour.minimap &&
    minimaps.length > 0 &&
    minimap &&
    minimap.originX != null &&
    minimap.originY != null &&
    minimap.width != null &&
    minimap.height != null &&
    minimap.ppm != null
  ) {
    const { hotspots, custom } = minimap;
    let foundHotspot: any = null;
    hotspots.forEach((hotspot: any) => {
      if (hotspot.scanId === sweep.sid || hotspot.scanId === sweep.id || hotspot.scanId === sweep.uuid || hotspot.scanId === sweep.sweep_uuid) {
        hotspot.active = true;
        foundHotspot = hotspot;
      } else {
        hotspot.active = false;
      }
    });
    if (foundHotspot) {
      px = foundHotspot.x;
      py = foundHotspot.y;
    } else if (!custom) {
      px = (((sweep.position?.x - minimap.originX) * minimap.ppm) / minimap.width) * 100;
      py = (((sweep.position?.z * -1 - minimap.originY) * minimap.ppm) / minimap.height) * 100;
    }
  }
  return { px, py, minimaps };
}
